import React from 'react'
import heroVideo from "../assets/vdo.mp4"; // replace with your video file
import { motion } from "framer-motion";
import HeadingBlock from "../Components/HeadingBlock";
import ListWithIcon from "../Components/ListWithIcon";
import { CheckCircle} from "lucide-react";
import Button from "../Components/Button";
import { Drone, Leaf, BookOpen, ArrowRight} from "lucide-react";
import Iconcard from "../Components/Iconcard";
import { Sprout, Users, ShieldCheck } from "lucide-react";  
import a1 from '../assets/Home_The Women Behind the Wings.webp'
import a4 from '../assets/Home_Who We Are.webp'
import a2 from '../assets/bg6.jpg'
import a3 from '../assets/Home_Why This Matters Beyond the Fields.webp'
import Testimonials from "../Components/Testimonials";
import SectionReveal from '../Components/SectionReveal';
import FeaturesGrid from '../Components/FeaturesGrid';
import GridComp from '../Components/GridComp';
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';

const Home = () => {
  
    const heading = "From Soil to Sky: How Drone Didis are Changing";
const bullets = [
  { title: "Sprays with Precision, Harvests with Abundance",desc:"No more guesswork. Drones deliver fertilizers and pesticides exactly where crops need them, leading to healthier plants and a bigger harvest." },
  { title: "Water Saved, Time Gained",desc:"The work that used to take several days is now done in just a few hours. With the help of drones, farmers save water, save labour, and get time for their families." },
  { title: "Stronger Fields, Stronger Futures",desc:"By reducing wastage and protecting crops from disease early, drones help farmers maximize yields while minimizing risk." },
];
const bullets1 = [
  { title: "From Villagers to Visionaries :",desc:"Every woman flying a drone is more than just a pilot - she is a pioneer. From the fields of villages to the buzzing skies, Drone Didis are showing the world what empowerment means." },
  { title: "Farmers Today, Entrepreneurs Tomorrow :",desc:"With every flight, the Drone Didis are not just growing crops - they are also building a business. Renting out drones to neighboring farmers means additional income and stronger economic independence." },
  { title: "Trained to Lead, Ready to Inspire :",desc:"The scheme provides training for drone pilots and assistants, giving women the skills to take charge of cutting-edge technology and inspiring the next generation of leaders." },
  
];
const features = [
  { 
    icon: <Sprout className="w-8 h-8" />, 
    title: "Eco-Friendly Growth", 
    desc: "By using fewer chemicals and better spraying methods, Drone Didi is protecting soil, water, and the environment." 
  },
  { 
    icon: <Users className="w-8 h-8" />, 
    title: "Families Flourish, Communities Rise", 
    desc: "Every rupee earned empowers not just a woman but her entire family. And every community becomes stronger with Drone Didis." 
  },
  { 
    icon: <ShieldCheck className="w-8 h-8" />, 
    title: "Future-Proof Farming", 
    desc: "It's not just about today's harvest. Drone Didi aims to build farms that are sustainable, profitable, and resilient for the future." 
  },
];
 const services = [
    {
      icon: <Drone className="w-10 h-10 text-green-500" />,
      title: "Drone Health Check",
      description:
        "A healthy drone, a happy Didi.” We ensure your machine is always ready to work. Includes complete inspection, battery testing, software updates, and preventive maintenance.",
    },
    {
      icon: <Leaf className="w-10 h-10 text-green-500" />,
      title: "Repair & Maintenance + Spare Parts Hub",
      description:
        "Fix small problems before they break big dreams.” Quick, affordable repairs, regular maintenance packages, and 100% authentic spare parts with quick shipping.",
    },
    {
      icon: <BookOpen className="w-10 h-10 text-green-500" />,
      title: "Advisory & Data Analytics",
      description:
        "Smart data. Smarter farming.” Turning drone-collected data into practical insights for crop health analysis, soil mapping, yield forecasting, and custom advisory.",
    },
     {
      icon: <BookOpen className="w-10 h-10 text-green-500" />,
      title: "Technical Support Helpdesk",
      description:
        "Whenever you’re stuck, we’re just a call away.” Dedicated phone and WhatsApp helpline, troubleshooting guidance, software support, and remote assistance.",
    },
  ];
  return (
    <>
    <Helmet>
        <title>Drone Didi: The Women Behind The Wings</title>

        <meta
          name="description"
          content="Drone Didi is an initiative born out of the need to combine technology with women empowerment. We aspire eco-friendly growth, families flourish, communities rise and future-proof farming. "
        />

        <link
          rel="canonical"
          href="https://dronedidi.co.in"
        />
      </Helmet>
     <section className="w-full bg-green-950 text-white pt-20 overflow-hidden">
        <div className="flex flex-col lg:flex-row w-full">
          
          {/* Left Section - Slanted Video */}
       <div 
  className="relative w-full lg:w-1/2 h-[300px] md:h-[600px] overflow-hidden"
  style={{ clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)" }}
>
  <video
    src={heroVideo}
    autoPlay
    loop
    muted
    playsInline
    className="absolute top-0 left-0 w-full h-full object-cover min-w-full min-h-full"
  />
</div>


          {/* Right Section - Content */}
        <div className="w-full lg:w-1/2 p-6 md:p-12 flex flex-col justify-center ">
      
      {/* Animated Heading */}
      <motion.h1
        className="text-3xl md:text-5xl font-bold mb-4 leading-snug flex flex-wrap"
        initial="hidden"
        animate="visible"
        variants={{
          visible: { transition: { staggerChildren: 0.05 } },
        }}
      >
        {heading.split("").map((char, index) => (
          <motion.span
            key={index}
            className="inline-block"
            variants={{
              hidden: { opacity: 0, x: 20 },
              visible: { opacity: 1, x: 0 },
            }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            {char === " " ? "\u00A0" : char}
          </motion.span>
        ))}
        <span className="text-[#d59640]">Farming Forever</span>
      </motion.h1>

      {/* Subheading */}
      <motion.h2
        className="text-lg md:text-2xl font-semibold text-gray-300 mb-4"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
      >
        A New Chapter in Farming
      </motion.h2>


      {/* Paragraph */}
   <motion.p
  className="text-sm md:text-base text-gray-400 leading-relaxed mb-6"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 1, duration: 0.6, ease: 'easeOut' }}
>
  Farming in India has always been about <span className="font-semibold text-white">sweat, soil, and sunshine</span>.  
  But today, with the <span className="font-bold text-white">Namo Drone Didi Scheme</span>, farming is also about  
  <span className="font-semibold text-white"> sky, speed, and smartness</span>.  
  Women are no longer just tilling the land – they are  
  <span className="font-bold text-white"> piloting change from above</span>.
</motion.p>

{/* Vision Statement */}



      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">
  <Link to="/drone_health_check">
    <motion.button
      className="bg-green-500 hover:bg-green-600 text-white font-medium px-6 py-3 rounded-full shadow-lg transition"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.5 }}
    >
      Explore Our Services
    </motion.button>
  </Link>

  <Link to="#">
    <motion.button
      className="bg-white text-green-600 hover:bg-gray-100 font-medium px-6 py-3 rounded-full shadow-lg transition"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.6, duration: 0.5 }}
    >
      Join Training
    </motion.button>
  </Link>
</div>
    </div>
        </div>
      </section>
<SectionReveal>
{/* About Drone Didi Section */}
<section className="w-full bg-white py-10 px-6 md:px-16">
  <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10">
    
  

    {/* Right Side - Content */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="w-full lg:w-1/2"
    >
  
  <HeadingBlock
        subtitle="Impact with Purpose: Drones & Women Empowerment"
        title="Who We Are"
          align="left"

        // highlight="Agency"
      />
      {/* About Text */}
      <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">
        Drone Didi is an initiative born out of the need to combine technology with 
        women empowerment. In rural India, women contribute significantly to agriculture, 
        yet their participation in modern farming technologies is limited.
      </p>

     
      <ListWithIcon
  items={bullets}
  icon={CheckCircle}
  size="lg"
  layout="vertical"
  iconColor="text-green-600"
  variant="soft"
  iconBg="bg-green-50"
  className="my-6"
/>
{/* <ListWithIcon
  items={["Safe Operations", "Sustainable Practices", "On-field Support"]}
  icon={<span>🚁</span>}
  size="sm"
  layout="plain"
  iconColor="text-emerald-600"
  variant="plain"
/>
<ListWithIcon
  items={[
    { title: "Certified Training", desc: "Curriculum aligned with DGCA norms" },
    { title: "Real Projects", desc: "Crop spraying, mapping, monitoring" },
    { title: "Job Pathways", desc: "Partners & local opportunities" },
    { title: "Community Impact", desc: "Village-level awareness drives" },
  ]}
  icon={GraduationCap}
  size="lg"
  layout="grid"
  cols="grid-cols-1 md:grid-cols-2"
  iconColor="text-green-700"
  variant="soft"
  iconBg="bg-amber-50"
  className="mt-8"
/> */}
{/* <Button text="Explore Services" to="/services" size="lg" />
<Button text="Learn More" href="https://www.droneindustry.com" size="lg" />
<Button text="Join Workshop" to="/training" bgGradient="bg-gradient-to-r from-purple-500 to-pink-500" size="lg" /> */}



      {/* Inspirational Line */}
      <p className="italic text-gray-600 mb-6">
        With Drone Didi, we dream of a future where every village has skilled women 
        drone operators leading the path toward modern farming.
      </p>


  <Button
    text="Know More About Us"
    to="/about"
    size="lg"
    bgGradient="bg-gradient-to-r from-green-400 to-green-600"
  />

    </motion.div>
      {/* Left Side - Image/Illustration */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      className="w-full lg:w-1/2"
    >
      <img 
        src={a4} // replace with actual image
        alt="Drone Didi Training"
        className="w-full"
      />
    </motion.div>
  </div>
</section>
</SectionReveal>
<SectionReveal>
  <section className="max-w-7xl mx-auto px-4 py-10">
    
  <HeadingBlock
        subtitle="What We Do"
        title="Our services are designed to meet the needs of farmers, communities, and aspiring entrepreneurs."
          align="center"

        // highlight="Agency"
      />
      <div className="grid md:grid-cols-2 my-8 gap-8">
        {services.map((service, index) => (
          <Iconcard
            key={index}
            icon={service.icon}
              // iconPosition="top-right"
                iconPosition="top-left"
  cardBg="bg-[#bde2ca]"      // dark red
  iconBg="bg-[#1e4b39]"          // light blue
  // txtcolor="text-white"
  // iconPosition="top-left"

            title={service.title}
            description={service.description}
            borderGradient="from-green-400 to-green-600"
            arrowIcon={<ArrowRight className="w-5 h-5 text-green-500" />}
          />
        ))}
      </div>
      <Button
    text="View Services"
    to="/about"
    size="lg"
    align="center"
    bgGradient="bg-gradient-to-r from-green-400 to-green-600"
  />

    </section>
  </SectionReveal>
<section
  className="relative w-full bg-cover bg-center bg-fixed p-10"
  style={{ backgroundImage: `url(${a2})` }}
>
  {/* Overlay */}
  <div className="absolute inset-0 bg-gradient-to-r from-green-900/90 to-green-500/50"></div>

  <div className="relative z-10 max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10">
    {/* Left Side - Image/Illustration */}
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
      className="w-full lg:w-1/2"
    >
      <img
        src={a1}
        alt="Drone Didi Training"
        className="w-full rounded-lg shadow-lg"
      />
    </motion.div>

    {/* Right Side - Content */}
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="w-full lg:w-1/2"
    >
      <h2 className="text-5xl text-orange-400 font-bold drop-shadow-[2px_0px_1px_black]">
        Drone Didis: The Women Behind the Wings
      </h2>

      <ListWithIcon
        items={bullets1}
        icon={CheckCircle}
        size="lg"
        itemcolor="text-white"
        layout="vertical"
        iconColor="text-green-600"
        variant="soft"
        iconBg="bg-yellow-50"
        className="my-6"
      />
    </motion.div>
  </div>
</section>

<section className="bg-gray-50 py-16">
  <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 p-6 lg:px-16 items-stretch">
    
    {/* ✅ LEFT: FeaturesGrid */}
    <div>
      <h2 className="text-3xl md:text-4xl font-bold mb-4">
        Why This Matters Beyond the Fields?
      </h2>
      <FeaturesGrid
        features={features}
        cols={1}
        textColor="text-green-900"
        descColor="text-gray-700"
        iconColor="text-orange-500"
        dividerFrom="after:from-green-200"
        dividerTo="after:to-green-900"
      />
    </div>

    {/* ✅ RIGHT: Image */}
    <div className="flex">
      <img
        src={a3}
        alt="Feature illustration"
        className="h-full w-full object-cover rounded-2xl shadow-lg"
      />
    </div>

  </div>
</section>


<div className="py-12">
    <HeadingBlock
        subtitle="Success Stories"
        title="Inspiring Stories of Change"
          align="center"

        // highlight="Agency"
      />
      <Testimonials/>

     <section
      className="relative bg-cover bg-center bg-fixed text-white py-20 px-6 md:px-12 lg:px-20"
      style={{ backgroundImage: `url(${a2})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 text-center">
     <motion.h2
  className="text-3xl md:text-4xl font-extrabold mb-10 leading-tight"
  initial={{ opacity: 0, y: -40 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.7, ease: "easeOut" }}
>
  
  Every drone that rises into the sky is not just a machine; it's a woman's 
  <span className="text-[#f9a024]"> dream</span>, her family's hope, and her community's pride.  
  With Drone Didis leading the way, Indian agriculture isn't just transforming - it's soaring into the future.
</motion.h2>


       

        {/* Buttons */}
        <motion.div
          className="flex flex-col md:flex-row gap-5 justify-center"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
        >
          <Button
            text="Contact Us Today"
            to="/contact"
            size="lg"
            bgGradient="bg-gradient-to-r from-[#f9a024] to-yellow-300"
            textColor="text-gray-900"
          />
          <Button
            text="Enroll for Training"
            to="/training"
            size="lg"
            bgGradient="bg-white"
            textColor="text-green-700"
          />
        </motion.div>
      </div>
    </section>
</div>
{/* 
 <GridComp
  title="Your Health, Our Priority"
  highlight="24/7 Care"
  paragraphs={["Get treatment from the best healthcare professionals."]}
  bullets={["Emergency Support", "Affordable Packages"]}
    listItems={["Certified Doctors", "24/7 Online Consultation", "Affordable Pricing"]}
  reverse={true}
    buttons={[{ label: "Create Account", type: "primary", link: "/signup" }]}
  image={a2}
/>  */}
    </>
  )
}

export default Home
